import { render, staticRenderFns } from "./ReceipsPayment.vue?vue&type=template&id=658a4685&scoped=true&"
import script from "./ReceipsPayment.vue?vue&type=script&lang=js&"
export * from "./ReceipsPayment.vue?vue&type=script&lang=js&"
import style0 from "./ReceipsPayment.vue?vue&type=style&index=0&id=658a4685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a4685",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VCardTitle,VDivider,VSwitch})
